import { FC } from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

type DialogWithCloseProps = {
  onClose: () => void;
  disableBackdropClose?: boolean;
} & Omit<DialogProps, "onClose">;

const DialogWithClose: FC<DialogWithCloseProps> = ({
  onClose,
  disableBackdropClose = false,
  children,
  ...props
}) => {
  const handleClose: DialogProps["onClose"] = (_event, reason) => {
    if (
      disableBackdropClose &&
      (reason === "backdropClick" || reason === "escapeKeyDown")
    ) {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      PaperProps={{ sx: { borderRadius: "6px" } }}
      {...props}
      onClose={handleClose}
      disableScrollLock
    >
      {onClose ? (
        <IconButton
          aria-label="Exit button"
          onClick={() => onClose()}
          sx={{
            position: "absolute",
            right: "10px",
            top: "10px",
            width: "25px",
            height: "25px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      ) : undefined}

      {children}
    </Dialog>
  );
};

export default DialogWithClose;
